import { render, staticRenderFns } from "./NotifySend.vue?vue&type=template&id=4c1159ca&scoped=true"
import script from "./NotifySend.vue?vue&type=script&lang=js"
export * from "./NotifySend.vue?vue&type=script&lang=js"
import style0 from "./NotifySend.vue?vue&type=style&index=0&id=4c1159ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1159ca",
  null
  
)

export default component.exports